var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCallIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5748 6.63877C13.7878 6.1172 14.3906 5.86414 14.9212 6.07354C15.7276 6.39179 16.457 6.8728 17.0625 7.48549C17.6679 8.09818 18.1358 8.82892 18.436 9.63048C18.6335 10.1579 18.3587 10.7429 17.8221 10.9371C17.2856 11.1312 16.6905 10.8611 16.493 10.3336C16.2928 9.79925 15.9809 9.31209 15.5773 8.90363C15.1737 8.49517 14.6874 8.1745 14.1498 7.96233C13.6192 7.75293 13.3618 7.16035 13.5748 6.63877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5369 2.79776C13.6907 2.22376 14.2807 1.88313 14.8547 2.03693C16.6791 2.52577 18.3427 3.48623 19.6782 4.82178C21.0138 6.15732 21.9742 7.82088 22.4631 9.64527C22.6169 10.2193 22.2762 10.8093 21.7022 10.9631C21.1282 11.1169 20.5382 10.7762 20.3844 10.2022C19.9934 8.74273 19.225 7.41188 18.1566 6.34344C17.0881 5.27501 15.7573 4.50664 14.2978 4.11557C13.7238 3.96176 13.3831 3.37176 13.5369 2.79776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.009 8.37675C10.3302 5.9243 7.88659 4.40954 5.4684 5.21613C3.8929 5.7416 2.93384 6.72194 2.6159 8.02953C2.32039 9.24493 2.6284 10.5565 3.10677 11.7156C4.07009 14.0498 5.9767 16.3623 7.0562 17.4426C8.1108 18.498 10.42 20.4129 12.7585 21.385C13.9197 21.8677 15.2361 22.1811 16.4571 21.8863C17.7712 21.569 18.7565 20.605 19.2848 19.0184C20.0902 16.6003 18.5782 14.1548 16.1263 13.4752L16.1263 13.4752C14.4503 13.0106 12.6927 13.4536 11.4932 14.5301C11.2117 14.3121 10.9409 14.074 10.6827 13.8155C10.4232 13.5558 10.1841 13.2834 9.96537 13.0001C11.0335 11.8002 11.4715 10.0479 11.009 8.37675L11.009 8.37675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCallIc);
export default __webpack_public_path__ + "static/media/contactCall_ic.1b2b6f06.svg";
export { ForwardRef as ReactComponent };